module.exports = __webpack_public_path__ + "static/img/7006.696fe53a.png";